import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import Auth from "@/layout/auth/auth.vue";

// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";

// Users pages
import User from "@/pages/user/users.vue";
import EditUser from "@/pages/user/_users.vue";

// Category Pages
import Category from "@/pages/category/category.vue";
import EditCategory from "@/pages/category/_category.vue";

// Comment Pages
import Comments from "../pages/comments/comment";
import EditComment from "../pages/comments/_comment";

// Content Pages
import Contents from "../pages/contents/content";
import EditContent from "../pages/contents/_content";

// Avatar Pages
import Avatar from "../pages/avatar/avatar";
import EditAvatar from "../pages/avatar/_avatar";

// Story Pages
import Story from "@/pages/story/story.vue";
import EditStory from "@/pages/story/_story.vue";

// Plan Pages
import Plan from "@/pages/plan/plan.vue";
import EditPlan from "@/pages/plan/_plan.vue";

// Voucher Pages
import Voucher from "@/pages/vouchers/voucher.vue";
import EditVoucher from "@/pages/vouchers/_voucher.vue";

// Order Pages
import Order from "@/pages/orders/order.vue";
import EditOrder from "@/pages/orders/_order.vue";

import Version from "../pages/settings/versions/versions";
import EditVersion from "../pages/settings/versions/_versions";

import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";
import Login from "@/pages/auth/login.vue";
import Register from "@/pages/auth/register.vue";
import HomeSettings from "@/pages/settings/homeSettings.vue";
import topBanners from "../pages/settings/topBanners.vue";
import seri1 from "../pages/settings/seriesBanners/banners-s-1.vue";
import seri2 from "../pages/settings/seriesBanners/banners-s-2.vue";
import seri3 from "../pages/settings/seriesBanners/banners-s-3.vue";
import yekta1 from "../pages/settings/yektaBanners/banner-y-1.vue";
import yekta2 from "../pages/settings/yektaBanners/banner-y-2.vue";
import yekta3 from "../pages/settings/yektaBanners/banner-y-3.vue";
import suggest from "../pages/settings/suggestBanners.vue";
import book from "../pages/books/book.vue";
import editBook from "../pages/books/_book.vue";
import addChapter from "../pages/books/addChapter.vue";
import editchapter from "../pages/books/editChapter.vue";
import pushNotifications from "../pages/pushNotifications.vue";

const routes = [{
        path: "",
        redirect: "/dashboard"
    },
    {
        path: "/auth",
        component: Auth,
        name: "auth",
        redirect: "/auth/login",
        children: [{
                path: "login",
                component: Login,
                name: "login",
                meta: {
                    title: "ورود",
                    preventLoggedIn: true
                }
            },
            {
                path: "register",
                component: Register,
                meta: {
                    title: "ثبت نام",
                    preventLoggedIn: true
                }
            }
        ]
    },
    {
        path: "/dashboard",
        component: DashboardLayout,
        redirect: "/dashboard/home",
        children: [{
                    path: "home",
                    name: "dashboard",
                    component: Dashboard,
                    meta: {
                        title: "داشبورد",
                        isAuth: true
                    }
                },

                // settings
                {
                    path: "home_settings",
                    name: "home_settings",
                    component: HomeSettings,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "top-banners",
                    name: "top-banners",
                    component: topBanners,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-s-1",
                    name: "banners-s-1",
                    component: seri1,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-s-2",
                    name: "banners-s-2",
                    component: seri2,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-s-3",
                    name: "banners-s-3",
                    component: seri3,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-y-1",
                    name: "banners-y-1",
                    component: yekta1,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-y-2",
                    name: "banners-y-2",
                    component: yekta2,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "banners-y-3",
                    name: "banners-y-3",
                    component: yekta3,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                {
                    path: "suggest",
                    name: "suggest",
                    component: suggest,
                    meta: {
                        title: "تنظیمات",
                        isAuth: true
                    }
                },
                // users
                {
                    path: "users",
                    name: "users",
                    component: User,
                    meta: {
                        title: "کاربران",
                        isAuth: true
                    }
                },
                {
                    path: "users/:id",
                    name: "edit_user",
                    component: EditUser,
                    meta: {
                        title: "مدیریت کاربران",
                        isAuth: true
                    }
                },

                // categories
                {
                    path: "category",
                    name: "categories",
                    component: Category,
                    meta: {
                        title: "دسته بندی ها",
                        isAuth: true
                    }
                },
                {
                    path: "category/:id",
                    name: "edit_category",
                    component: EditCategory,
                    meta: {
                        title: "مدیریت دسته بندی ها",
                        isAuth: true
                    }
                },

                // comments
                {
                    path: "comment",
                    name: "comments",
                    component: Comments,
                    meta: {
                        title: "نظرات",
                        isAuth: true
                    }
                },
                {
                    path: "comment/:id",
                    name: "edit_comment",
                    component: EditComment,
                    meta: {
                        title: "مدیریت نظرات",
                        isAuth: true
                    }
                },

                // content
                {
                    path: "content",
                    name: "contents",
                    component: Contents,
                    meta: {
                        title: "محتوا",
                        isAuth: true
                    }
                },
                {
                    path: "content/:id",
                    name: "edit_content",
                    component: EditContent,
                    meta: {
                        title: "مدیریت محتوا",
                        isAuth: true
                    }
                },

                // content
                {
                    path: "avatar",
                    name: "avatars",
                    component: Avatar,
                    meta: {
                        title: "آواتار",
                        isAuth: true
                    }
                },
                {
                    path: "avatar/:id",
                    name: "edit_avatar",
                    component: EditAvatar,
                    meta: {
                        title: "مدیریت آواتار",
                        isAuth: true
                    }
                },

                // stories
                {
                    path: "story",
                    name: "stories",
                    component: Story,
                    meta: {
                        title: "داستان ها",
                        isAuth: true
                    }
                },
                {
                    path: "story/:id",
                    name: "edit_story",
                    component: EditStory,
                    meta: {
                        title: "مدیریت داستان",
                        isAuth: true
                    }
                },
                // books
                {
                    path: "book",
                    name: "books",
                    component: book,
                    meta: {
                        title: "کتاب ها",
                        isAuth: true
                    }
                },
                {
                    path: "book/:id",
                    name: "editBook",
                    component: editBook,
                    meta: {
                        title: "مدیریت کتاب",
                        isAuth: true
                    }
                },
                {
                    path: "book/addChapter/:id",
                    name: "addChapter",
                    component: addChapter,
                    meta: {
                        title: "اضافه کردن قسمت جدید",
                        isAuth: true
                    }
                }, ,
                {
                    path: "book/editChapter/:id",
                    name: "editchapter",
                    component: editchapter,
                    meta: {
                        title: "   ویرایش قسمت",
                        isAuth: true
                    }
                },
                // plans
                {
                    path: "plans",
                    name: "plans",
                    component: Plan,
                    meta: {
                        title: "اشتراک",
                        isAuth: true
                    }
                },
                {
                    path: "plan/:id",
                    name: "edit_plan",
                    component: EditPlan,
                    meta: {
                        title: "مدیریت اشتراک",
                        isAuth: true
                    }
                },

                // plans
                {
                    path: "vouchers",
                    name: "vouchers",
                    component: Voucher,
                    meta: {
                        title: "کدهای تخفیف",
                        isAuth: true
                    }
                },
                {
                    path: "voucher/:id",
                    name: "edit_voucher",
                    component: EditVoucher,
                    meta: {
                        title: "کدهای تخفیف",
                        isAuth: true
                    }
                },

                // orders
                {
                    path: "orders",
                    name: "orders",
                    component: Order,
                    meta: {
                        title: "سفارش‌ها",
                        isAuth: true
                    }
                },
                {
                    path: "order/:id",
                    name: "edit_order",
                    component: EditOrder,
                    meta: {
                        title: "مدیریت سفارش",
                        isAuth: true
                    }
                },

                // versions settings
                {
                    path: "versions",
                    name: "versions",
                    component: Version,
                    meta: {
                        title: "نسخه ها",
                        isAuth: true
                    }
                },
                {
                    path: "versions/:id",
                    name: "edit_version",
                    component: EditVersion,
                    meta: {
                        title: "مدیریت نسخه ها",
                        isAuth: true
                    }
                },

                {
                    path: "pushNotification",
                    name: "pushnotif",
                    component: pushNotifications
                },
                {
                    path: "notifications",
                    name: "notifications",
                    component: Notifications
                },
                {
                    path: "/404",
                    component: NotFound,
                    meta: {
                        title: "صفحه مورد نظر پیدا نشد",
                        isAuth: true
                    }
                }
            ]
            // redirect: "/dashboard",
    },
    {
        path: "*",
        name: "error_page",
        redirect: "/404"
    }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;